import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScreenReaderAnnouncer = () => {
    const location = useLocation();
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (location.pathname === "/GrievanceForm") {
            setMessage("You have entered the Grievance Form page");
        } else if (location.pathname === "/managed-dental-guard") {
            setMessage("You have entered the managed dental guard");
        }
        else if (location.pathname === "/") {
            setMessage("You are in home page");
        }
        else {
            setMessage("");
        }
    }, [location]);

    return (
        <div aria-live="polite" className="sr-only">
            {message}
        </div>
    );
};

export default ScreenReaderAnnouncer;
